var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.layout === 'noheader')?_c('noheader'):(_vm.layout === 'login')?_c('Login'):(_vm.layout === 'landing')?_c('LandingLayout'):_c('main-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }